export {LayoutSwitcherComponent} from '@shared/layout/layout-switcher.component';
export {LayoutService} from '@shared/layout/layout.service';
export {SmartadminLayoutModule} from '@shared/layout/layout.module';

export * from '@shared/layout/footer'
export * from '@shared/layout/header'
export * from '@shared/layout/navigation'
export * from '@shared/layout/ribbon'
export * from '@shared/layout/shortcut'





// WEBPACK FOOTER //
// ./src/app/shared/layout/index.ts